// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3QQdC","title":"Info_title__3opPw","links":"Info_links__2W1Yh","link":"Info_link__2Bwsa","logo":"Info_logo__2mxGE"};